<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <ListaPontos />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import ListaPontos from "../Components/Listagens/ListaPontos.vue";
export default {
  name: "ListReserve",
  components: {
    ListaPontos,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>